import { Backdrop, CircularProgress } from '@mui/material';
import React, { createContext, useCallback, useContext, useState } from 'react';
import io from 'socket.io-client';

import api from '../services/api';
import { useAuth } from './AuthContext';
import { urls } from '../config';

interface ContextData {
    setOpenLoading(open: boolean): void;
    openLoading: boolean;
    handleOpenCollapseRecords(open: boolean): void;
    openCollapseRecords: boolean;
    setNotificationNextExpertise(open: boolean): void;
    notificationNextExpertise: boolean;
    setNotificationNextLegalProcess(open: boolean): void;
    notificationNextLegalProcess: boolean;
    setNotificationNextAudience(open: boolean): void;
    notificationNextAudience: boolean;
    setNotificationNextCustomerService(open: boolean): void;
    notificationNextCustomerService: boolean;
    setNotificationNextTask(open: boolean): void;
    notificationNextTask: boolean;
    handleOpenCollapseInvoicing(open: boolean): void;
    openCollapseInvoicing: boolean;
    handleOpenCollapsePermissions(open: boolean): void;
    openCollapsePermissions: boolean;
    handleOpenCollapseExpenditurePortions(open: boolean): void;
    openCollapseExpenditurePortions: boolean;
    listNotificationNextExpertise: any[];
    setListNotificationNextExpertise: (data: any[]) => void;
    listNotificationNextLegalProcess: any[];
    setListNotificationNextLegalProcess: (data: any[]) => void;
    listNotificationNextAudience: any[];
    setListNotificationNextAudience: (data: any[]) => void;
    listNotificationNextCustomerService: any[];
    setListNotificationNextCustomerService: (data: any[]) => void;
    listNotificationNextTask: any[];
    setListNotificationNextTask: (data: any[]) => void;
    listBirthdays: any[];
    setListBirthdays: (data: any[]) => void;
    setNotificationBirthDay(open: boolean): void;
    notificationBirthDay: boolean;
    configuration: any;
}

interface Data {
    id: string;
    body: any;
    view: boolean;
    active?: boolean;
    company?: {
        id: string;
        description: string;
    };
}

type Props = { children: React.ReactNode; message: any };

const ContextGlobal = createContext<ContextData>({} as ContextData);

// const ProviderGlobal: React.FC<Props> = ({ children, message }) => {
const ProviderGlobal: React.FC<Props> = ({ children }) => {
    const [open, setOpen] = useState(false);
    const { user } = useAuth();
    const [message, setMessage] = useState<any>({});
    const [loadAllData, setLoadAllData] = React.useState(false);
    const [notificationNextExpertise, setNotificationNextExpertise] = useState(
        () => {
            const notificationNextExpertise = localStorage.getItem(
                '@GESSIS:notificationNextExpertise',
            );

            if (notificationNextExpertise) {
                return true;
            }
            return false;
        },
    );
    const [notificationNextLegalProcess, setNotificationNextLegalProcess] =
        useState(() => {
            const notificationNextLegalProcess = localStorage.getItem(
                '@GESSIS:notificationNextLegalProcess',
            );

            if (notificationNextLegalProcess) {
                return true;
            }
            return false;
        });
    const [notificationNextAudience, setNotificationNextAudience] = useState(
        () => {
            const result = localStorage.getItem(
                '@GESSIS:notificationNextAudience',
            );

            if (result) {
                return true;
            }
            return false;
        },
    );
    const [
        notificationNextCustomerService,
        setNotificationNextCustomerService,
    ] = useState(() => {
        const result = localStorage.getItem(
            '@GESSIS:notificationNextCustomerService',
        );

        if (result) {
            return true;
        }
        return false;
    });
    const [notificationNextTask, setNotificationNextTask] = useState(() => {
        const result = localStorage.getItem('@GESSIS:notificationNextTask');

        if (result) {
            return true;
        }
        return false;
    });

    const messageUseMemo = React.useMemo(() => {
        return message;
    }, [message]);

    const [listNotificationNextExpertise, setListNotificationNextExpertise] =
        React.useState<any[]>(() => {
            let items: any = localStorage.getItem('@GESSIS:nextExpertise');
            if (items) {
                items = JSON.parse(items);
                return items;
            }
            return [];
        });
    const [
        listNotificationNextLegalProcess,
        setListNotificationNextLegalProcess,
    ] = React.useState<Data[]>(() => {
        let items: any = localStorage.getItem('@GESSIS:nextLegalProcess');
        if (items) {
            items = JSON.parse(items);
            return items;
        }
        return [];
    });
    const [listNotificationNextAudience, setListNotificationNextAudience] =
        React.useState<Data[]>(() => {
            let items: any = localStorage.getItem('@GESSIS:nextAudience');
            if (items) {
                items = JSON.parse(items);
                return items;
            }
            return [];
        });
    const [
        listNotificationNextCustomerService,
        setListNotificationNextCustomerService,
    ] = React.useState<Data[]>(() => {
        let items: any = localStorage.getItem('@GESSIS:nextCustomerService');
        if (items) {
            items = JSON.parse(items);
            return items;
        }
        return [];
    });
    const [listNotificationNextTask, setListNotificationNextTask] =
        React.useState<Data[]>(() => {
            let items: any = localStorage.getItem('@GESSIS:nextTask');
            if (items) {
                items = JSON.parse(items);
                return items;
            }
            return [];
        });
    const [listBirthdays, setListBirthdays] = React.useState<any[]>(() => {
        let items: any = localStorage.getItem('@GESSIS:birthday');
        if (items) {
            items = JSON.parse(items);
            return items;
        }
        return [];
    });
    const [notificationBirthDay, setNotificationBirthDay] = useState(false);
    const [openCollapseRecords, setOpenCollapseRecords] = useState(() => {
        const openCollapseRecords = localStorage.getItem(
            '@GESSIS:openCollapseRecords',
        );

        if (openCollapseRecords) {
            return true;
        }
        return false;
    });

    const configuration = React.useMemo(() => {
        let configData = localStorage.getItem('@GESSIS_ESTOQUE:configuration');

        if (configData) {
            return JSON.parse(configData);
        }
        return {};
    }, [loadAllData]);

    const [openCollapseInvoicing, setOpenCollapseInvoicing] = useState(() => {
        const openCollapseInvoicing = localStorage.getItem(
            '@GESSIS:openCollapseInvoicing',
        );

        if (openCollapseInvoicing) {
            return true;
        }
        return false;
    });

    const [openCollapsePermissions, setOpenCollapsePermissions] = useState(
        () => {
            const openCollapsePermissions = localStorage.getItem(
                '@GESSIS:openCollapsePermissions',
            );

            if (openCollapsePermissions) {
                return true;
            }
            return false;
        },
    );

    const [
        openCollapseExpenditurePortions,
        setOpenCollapseExpenditurePortions,
    ] = useState(() => {
        const openCollapseExpenditurePortions = localStorage.getItem(
            '@GESSIS:openCollapseExpenditurePortions',
        );

        if (openCollapseExpenditurePortions) {
            return true;
        }
        return false;
    });

    const loadConfiguration = useCallback(async () => {
        const response = await api.get('configuration/unique');
        let { data } = response;

        if (data?.id) {
            localStorage.setItem('@GESSIS:configuration', JSON.stringify(data));
        } else {
            localStorage.setItem('@GESSIS:configuration', JSON.stringify({}));
        }

        if (data?.id) {
            setLoadAllData(true);
        }
    }, []);

    const loadNotificationNextExpertiseByUser = React.useCallback(
        async (daysInAdvance?: number) => {
            try {
                if (user && localStorage.getItem('@GESSIS:token')) {
                    let url = `expertise/greaterthan?user.id=${user.sub}`;
                    if (daysInAdvance) {
                        url = `${url}&daysInAdvance=${daysInAdvance}`;
                    }
                    const response = await api.get(url);
                    let { data } = response;
                    data = data.data;
                    data = data.map((d: any) => ({ ...d, finished: false }));

                    // Condição para disparar notificação
                    let items: any = localStorage.getItem(
                        '@GESSIS:nextExpertise',
                    );
                    if (items) {
                        items = JSON.parse(items);
                    }
                    setListNotificationNextExpertise(data);
                    // if (
                    //     data &&
                    //     data.filter((r: any) => !r.view).length > 0 &&
                    //     login
                    // ) {
                    //     setNotificationNextExpertise(true);
                    // }
                    data.forEach((d: any) => {
                        d.token = localStorage.getItem('@GESSIS:token');
                    });
                    if (data.length > 0) {
                        localStorage.setItem(
                            '@GESSIS:nextExpertise',
                            JSON.stringify(data),
                        );
                    } else if (localStorage.getItem('@GESSIS:nextExpertise')) {
                        localStorage.setItem(
                            '@GESSIS:nextExpertise',
                            JSON.stringify([]),
                        );
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        [user],
    );

    const loadNotificationNextLegalProcessByUser = React.useCallback(
        async (daysInAdvance?: number) => {
            try {
                if (user && localStorage.getItem('@GESSIS:token')) {
                    let url = `legal-process/greaterthan?user.id=${user.sub}`;
                    if (daysInAdvance) {
                        url = `${url}&daysInAdvance=${daysInAdvance}`;
                    }
                    const response = await api.get(url);
                    let { data } = response;
                    data = data.data;
                    data = data.map((d: any) => ({ ...d, finished: false }));

                    // Condição para disparar notificação
                    let items: any = localStorage.getItem(
                        '@GESSIS:nextLegalProcess',
                    );
                    if (items) {
                        items = JSON.parse(items);
                    }
                    setListNotificationNextLegalProcess(data);
                    // if (
                    //     data &&
                    //     data.filter((r: any) => !r.view).length > 0 &&
                    //     login
                    // ) {
                    //     setNotificationNextLegalProcess(true);
                    // }
                    data.forEach((d: any) => {
                        d.token = localStorage.getItem('@GESSIS:token');
                    });
                    if (data.length > 0) {
                        localStorage.setItem(
                            '@GESSIS:nextLegalProcess',
                            JSON.stringify(data),
                        );
                    } else if (
                        localStorage.getItem('@GESSIS:nextLegalProcess')
                    ) {
                        localStorage.setItem(
                            '@GESSIS:nextLegalProcess',
                            JSON.stringify([]),
                        );
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        [user],
    );

    const loadNotificationNextAudienceByUser = React.useCallback(
        async (daysInAdvance?: number) => {
            try {
                if (user && localStorage.getItem('@GESSIS:token')) {
                    let url = `audiences/greaterthan?user.id=${user.sub}`;
                    if (daysInAdvance) {
                        url = `${url}&daysInAdvance=${daysInAdvance}`;
                    }
                    const response = await api.get(url);
                    let { data } = response;
                    data = data.data;
                    data = data.map((d: any) => ({ ...d, finished: false }));

                    // Condição para disparar notificação
                    let items: any = localStorage.getItem(
                        '@GESSIS:nextAudience',
                    );
                    if (items) {
                        items = JSON.parse(items);
                    }
                    setListNotificationNextAudience(data);
                    data.forEach((d: any) => {
                        d.token = localStorage.getItem('@GESSIS:token');
                    });
                    if (data.length > 0) {
                        localStorage.setItem(
                            '@GESSIS:nextAudience',
                            JSON.stringify(data),
                        );
                    } else if (localStorage.getItem('@GESSIS:nextAudience')) {
                        localStorage.setItem(
                            '@GESSIS:nextAudience',
                            JSON.stringify([]),
                        );
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        [user],
    );

    const loadNotificationNextCustomerServiceByUser = React.useCallback(
        async (daysInAdvance?: number) => {
            try {
                if (user && localStorage.getItem('@GESSIS:token')) {
                    let url = `customer-services/greaterthan?user.id=${user.sub}`;
                    if (daysInAdvance) {
                        url = `${url}&daysInAdvance=${daysInAdvance}`;
                    }
                    const response = await api.get(url);
                    let { data } = response;
                    data = data.data;
                    data = data.map((d: any) => ({ ...d, finished: false }));

                    // Condição para disparar notificação
                    let items: any = localStorage.getItem(
                        '@GESSIS:nextCustomerService',
                    );
                    if (items) {
                        items = JSON.parse(items);
                    }
                    setListNotificationNextCustomerService(data);
                    data.forEach((d: any) => {
                        d.token = localStorage.getItem('@GESSIS:token');
                    });
                    if (data.length > 0) {
                        localStorage.setItem(
                            '@GESSIS:nextCustomerService',
                            JSON.stringify(data),
                        );
                    } else if (
                        localStorage.getItem('@GESSIS:nextCustomerService')
                    ) {
                        localStorage.setItem(
                            '@GESSIS:nextCustomerService',
                            JSON.stringify([]),
                        );
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        [user],
    );

    const loadNotificationNextTaskByUser = React.useCallback(
        async (daysInAdvance?: number) => {
            try {
                if (user && localStorage.getItem('@GESSIS:token')) {
                    let url = `tasks/greaterthan?user.id=${user.sub}`;
                    if (daysInAdvance) {
                        url = `${url}&daysInAdvance=${daysInAdvance}`;
                    }
                    const response = await api.get(url);
                    let { data } = response;
                    data = data.data;
                    data = data.map((d: any) => ({ ...d, finished: false }));

                    // Condição para disparar notificação
                    let items: any = localStorage.getItem('@GESSIS:nextTask');
                    if (items) {
                        items = JSON.parse(items);
                    }
                    setListNotificationNextTask(data);
                    data.forEach((d: any) => {
                        d.token = localStorage.getItem('@GESSIS:token');
                    });
                    if (data.length > 0) {
                        localStorage.setItem(
                            '@GESSIS:nextTask',
                            JSON.stringify(data),
                        );
                    } else if (localStorage.getItem('@GESSIS:nextTask')) {
                        localStorage.setItem(
                            '@GESSIS:nextTask',
                            JSON.stringify([]),
                        );
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        [user],
    );

    React.useEffect(() => {
        let arrMessages = [];

        if (user?.sub && messageUseMemo?.type) {
            arrMessages = messageUseMemo.type.split(',');
        }

        if (arrMessages.length > 0) {
            const configLoad = {
                [`nextExpertise-${user.sub}`]: () => {
                    loadNotificationNextExpertiseByUser(
                        messageUseMemo?.data?.daysInAdvance,
                    );
                },
                [`nextLegalProcess-${user.sub}`]: () => {
                    loadNotificationNextLegalProcessByUser(
                        messageUseMemo?.data?.daysInAdvance,
                    );
                },
                [`nextAudience-${user.sub}`]: () => {
                    loadNotificationNextAudienceByUser(
                        messageUseMemo?.data?.daysInAdvance,
                    );
                },
                [`nextCustomerService-${user.sub}`]: () => {
                    loadNotificationNextCustomerServiceByUser(
                        messageUseMemo?.data?.daysInAdvance,
                    );
                },
                [`nextTask-${user.sub}`]: () => {
                    loadNotificationNextTaskByUser(
                        messageUseMemo?.data?.daysInAdvance,
                    );
                },
                configuration: () => {
                    loadConfiguration();
                },
            };

            for (const element of arrMessages) {
                if (configLoad[element]) {
                    configLoad[element]();
                }
            }
        }
    }, [
        message,
        loadConfiguration,
        user?.sub,
        loadNotificationNextExpertiseByUser,
        loadNotificationNextLegalProcessByUser,
        loadNotificationNextAudienceByUser,
        loadNotificationNextCustomerServiceByUser,
        loadNotificationNextTaskByUser,
        messageUseMemo,
    ]);

    const baseURL =
        process.env.REACT_APP_ENVIROMENT === 'local'
            ? urls.api.local
            : urls.api.prod;

    const [socket, setSocket] = useState<any>(null);
    React.useEffect(() => {
        let skt: any = null;
        if (!!user) {
            skt = io(baseURL, {
                transports: ['websocket', 'polling', 'flashsocket'],
                query: {
                    token: localStorage.getItem('@GESSIS:token'),
                    companyId: user.companyId,
                },
            });
            skt.on('msgToClient', (msg: any) => {
                setMessage(msg);
            });
            setSocket(skt);
        }
        return () => { skt?.disconnect(); };
    }, [user]);

    const loadBirthdayPerson = useCallback(async () => {
        try {
            // if (localStorage.getItem('@GESSIS:token')) {
            //     const response = await api.get(
            //         'notification?notification.notificationType=birthday&notification.active=1',
            //     );
            //     let { data } = response;
            //     data = data.data;
            //     // Condição para disparar notificação
            //     let items: any = localStorage.getItem('@GESSIS:birthday');
            //     if (items) {
            //         items = JSON.parse(items);
            //     }
            //     setListBirthdays(data);
            //     if (data && data.filter((r: any) => !r.view).length > 0) {
            //         setNotificationBirthDay(true);
            //     }
            //     data.forEach((d: any) => {
            //         d.token = localStorage.getItem('@GESSIS:token');
            //     });
            //     if (data.length > 0) {
            //         localStorage.setItem(
            //             '@GESSIS:birthday',
            //             JSON.stringify(data),
            //         );
            //     } else if (localStorage.getItem('@GESSIS:birthday')) {
            //         localStorage.setItem(
            //             '@GESSIS:birthday',
            //             JSON.stringify([]),
            //         );
            //     }
            // }
        } catch (error) {
            console.error(error);
        }
    }, [message]);

    const handleOpenCollapseRecords = (value: boolean) => {
        if (value) {
            localStorage.setItem('@GESSIS:openCollapseRecords', 'true');
            setOpenCollapseRecords(true);
        } else {
            localStorage.removeItem('@GESSIS:openCollapseRecords');
            setOpenCollapseRecords(false);
        }
    };

    const handleOpenCollapseInvoicing = (value: boolean) => {
        if (value) {
            localStorage.setItem('@GESSIS:openCollapseInvoicing', 'true');
            setOpenCollapseInvoicing(true);
        } else {
            localStorage.removeItem('@GESSIS:openCollapseInvoicing');
            setOpenCollapseInvoicing(false);
        }
    };

    const handleOpenCollapsePermissions = (value: boolean) => {
        if (value) {
            localStorage.setItem('@GESSIS:openCollapsePermissions', 'true');
            setOpenCollapsePermissions(true);
        } else {
            localStorage.removeItem('@GESSIS:openCollapsePermissions');
            setOpenCollapsePermissions(false);
        }
    };

    const handleOpenCollapseExpenditurePortions = (value: boolean) => {
        if (value) {
            localStorage.setItem(
                '@GESSIS:openCollapseExpenditurePortions',
                'true',
            );
            setOpenCollapseExpenditurePortions(true);
        } else {
            localStorage.removeItem('@GESSIS:openCollapseExpenditurePortions');
            setOpenCollapseExpenditurePortions(false);
        }
    };

    return (
        <ContextGlobal.Provider
            value={{
                setOpenLoading: setOpen,
                openLoading: open,
                openCollapseRecords,
                handleOpenCollapseRecords,
                notificationNextExpertise,
                setNotificationNextExpertise,
                notificationNextLegalProcess,
                setNotificationNextLegalProcess,
                notificationNextAudience,
                setNotificationNextAudience,
                notificationNextCustomerService,
                setNotificationNextCustomerService,
                notificationNextTask,
                setNotificationNextTask,
                handleOpenCollapseInvoicing,
                openCollapseInvoicing,
                openCollapsePermissions,
                handleOpenCollapsePermissions,
                openCollapseExpenditurePortions,
                handleOpenCollapseExpenditurePortions,
                listNotificationNextAudience,
                setListNotificationNextAudience,
                listNotificationNextExpertise,
                setListNotificationNextExpertise,
                listNotificationNextLegalProcess,
                setListNotificationNextLegalProcess,
                listNotificationNextCustomerService,
                setListNotificationNextCustomerService,
                listNotificationNextTask,
                setListNotificationNextTask,
                listBirthdays,
                setListBirthdays,
                notificationBirthDay,
                setNotificationBirthDay,
                configuration,
            }}>
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: theme => theme.zIndex.drawer + 1300,
                }}
                open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
            {children}
        </ContextGlobal.Provider>
    );
};

function useContextGlobal(): ContextData {
    const context = useContext(ContextGlobal);
    if (!context) {
        throw new Error('useToast must be used within a ProviderGlobal');
    }
    return context;
}

export { ProviderGlobal, useContextGlobal };
